import * as React from "react";

const LumaIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      fill="#762EAF"
      d="M11.952 1.008c.336-.022.703.006 1.04.024 4.503.249 8.486 3.342 9.914 7.609.03.089.062.177.08.27.108.38-.414.64-.635.326-.212-.3-.385-.642-.59-.953a9.695 9.695 0 0 0-9.19-4.229 9.7 9.7 0 0 0-6.463 3.6 9.65 9.65 0 0 0-2.051 7.173c.277 2.677 1.81 5.246 4.009 6.793q.333.234.683.444c.167.098.497.24.587.412.124.236-.038.426-.253.526-.22-.003-.611-.154-.827-.236-1.409-.535-2.575-1.278-3.684-2.289a11.1 11.1 0 0 1-3.384-6.172 13 13 0 0 1-.18-1.696 10 10 0 0 1 .03-1.21 11.18 11.18 0 0 1 2.931-6.758 11.25 11.25 0 0 1 6.568-3.508c.474-.073.936-.105 1.415-.126"
    ></path>
    <path
      fill="#0C21A4"
      d="M16.551 6.861c.166-.013.331.047.485.102 1.288.46 2.508 1.282 3.381 2.34a7.8 7.8 0 0 1 1.778 5.72c-.214 2.175-1.22 4.003-2.91 5.385a7.75 7.75 0 0 1-5.62 1.664c-2.2-.226-3.993-1.24-5.38-2.947a7.8 7.8 0 0 1-1.217-2.235c-.075-.217-.192-.478.038-.649a.38.38 0 0 1 .295-.07c.054.01.134.04.17.08.18.206.315.5.474.735a6.497 6.497 0 0 0 8.975 1.767 6.54 6.54 0 0 0 2.8-4.145 6.51 6.51 0 0 0-2.279-6.353c-.348-.286-.69-.484-1.074-.716-.317-.191-.223-.526.084-.678"
    ></path>
    <path
      fill="#1992A6"
      d="M12.227 7.589c.973-.092 2.172.256 2.994.778a5.07 5.07 0 0 1 1.95 2.29c.072.168.145.326.192.504.058.216-.1.44-.317.47-.322.045-.454-.366-.605-.58a4.2 4.2 0 0 0-.968-.997 3.98 3.98 0 0 0-2.989-.703 4 4 0 0 0-2.614 1.626c-.655.916-.854 1.979-.674 3.078a4.02 4.02 0 0 0 1.91 2.708c.07.046.165.089.226.15.273.273.09.556-.226.642-.654-.133-1.455-.609-1.96-1.048a5.04 5.04 0 0 1-1.724-3.502 5.04 5.04 0 0 1 1.215-3.647c.945-1.076 2.161-1.677 3.59-1.77"
    ></path>
  </svg>
);

export default LumaIcon;
